export default {
    namespaced: true,

    state: {
        clientId: null,
        token: null,
        tokenDateCreated: null,
        tokenDateExpiry: null,
        timerInterval: null,
        tokenExpirySeconds: null,
        tokenResponse: {},
        connection: {},
        connectionDiagnostics: [],
        connectionError: null,
        activeTransport: null
    },

    getters: {
        GetClientId(state) {
            return state.clientId
        },

        GetToken(state) {
            return state.token
        },

        GetTokenDateCreated(state) {
            return state.tokenDateCreated
        },

        GetTokenDateExpiry(state) {
            return state.tokenDateExpiry
        },

        GetTokenExpirySeconds(state) {
            return state.tokenExpirySeconds
        },

        GetTimerInterval(state) {
            return state.timerInterval
        },

        GetTokenResponse(state) {
            return state.tokenResponse
        },

        GetConnection(state) {
            return state.connection
        },

        GetConnectionDiagnostics(state) {
            return state.connectionDiagnostics
        },

        GetConnectionError(state) {
            return state.connectionError
        },

        GetActiveTransport(state) {
            return state.activeTransport
        }
    },

    mutations: {
        SET_CLIENT_ID(state, data) {
            state.clientId = data
        },

        SET_TOKEN(state, data) {
            state.token = data
        },

        SET_TOKEN_DATE_CREATED(state, data) {
            state.tokenDateCreated = data
        },

        SET_TOKEN_DATE_EXPIRY(state, data) {
            state.tokenDateExpiry = data
        },

        SET_TOKEN_EXPIRY_SECONDS(state, data) {
            state.tokenExpirySeconds = data
        },

        SET_TIMER_INTERVAL(state, data) {
            state.timerInterval = data
        },

        SET_TOKEN_RESPONSE(state, data) {
            state.tokenResponse = data
        },

        SET_CONNECTION(state, data) {
            state.connection = data
        },

        ADD_CONNECTION_DIAGNOSTIC(state, entry) {
            state.connectionDiagnostics.push(entry)
            if(state.connectionDiagnostics.length > 300) state.connectionDiagnostics.shift()
        },

        CLEAR_CONNECTION_DIAGNOSTICS(state) {
            state.connectionDiagnostics = []
            state.connectionError = null
        },

        SET_CONNECTION_ERROR(state, data) {
            state.connectionError = data
        },

        SET_ACTIVE_TRANSPORT(state, data) {
            state.activeTransport = data
        },

        // connectionError and connectionDiagnostics deliberately survive CLEAR: the diagnostics
        // modal stays open across the post-failure navigation (which dispatches ClearConnection)
        // and reads both from here. They reset at the start of the next connection attempt via
        // CLEAR_CONNECTION_DIAGNOSTICS. Watchers must not use immediate:true on connectionError,
        // or they will re-fire on this stale value when a component mounts.
        CLEAR(state) {
            state.clientId = null
            state.token = null
            state.tokenDateCreated = null
            state.tokenDateExpiry = null
            state.timerInterval = null
            state.tokenExpirySeconds = null
            state.tokenResponse = {}
            state.connection = {}
            state.activeTransport = null
        }
    },

    actions: {
        SetClientId({commit}, data) {
            commit('SET_CLIENT_ID', data)
        },

        SetToken({commit}, data) {
            commit('SET_TOKEN', data)
        },

        SetTokenDateCreated({commit}, data) {
            commit('SET_TOKEN_DATE_CREATED', data)
        },

        SetTokenDateExpiry({commit}, data) {
            commit('SET_TOKEN_DATE_EXPIRY', data)
        },

        SetTokenExpirySeconds({commit}, data) {
            commit('SET_TOKEN_EXPIRY_SECONDS', data)
        },

        SetTimerInterval({commit}, data) {
            commit('SET_TIMER_INTERVAL', data)
        },

        SetTokenResponse({commit}, data) {
            commit('SET_TOKEN_RESPONSE', data)
        },

        SetConnection({commit}, data) {
            commit('SET_CONNECTION', data)
        },

        AddConnectionDiagnostic({commit}, entry) {
            commit('ADD_CONNECTION_DIAGNOSTIC', entry)
        },

        ClearConnectionDiagnostics({commit}) {
            commit('CLEAR_CONNECTION_DIAGNOSTICS')
        },

        SetConnectionError({commit}, data) {
            commit('SET_CONNECTION_ERROR', data)
        },

        SetActiveTransport({commit}, data) {
            commit('SET_ACTIVE_TRANSPORT', data)
        },

        ClearConnection({commit}) {
            commit('CLEAR')
        }
    }
}